import { createAction } from "typesafe-actions";
const terminateAllEpicsAction = "/terminateAllEpics";
const terminateAllEpics = createAction(terminateAllEpicsAction)();
export {
  terminateAllEpics
};
//# sourceMappingURL=actions.js.map
